export const DS_PAGES = {
  'upgrade-offer': {
    className: 'upgrade-offer',
    banner: true,
    coupon: 'WE21ZE',
    pagePercentOff: '60%',
    offerEndDate: true,
    heroSectionOptions: {
      titleHTML: 'Get Full Access to <br> All 365 Data Science <br> Courses at 60% Off',
      subtitle: '<p>Learn the data skills that will take your career to the next level.</p><p>Upgrade to Premium plan and save 60% with our limited-time offer.</p>',
    },
    promoCardOptions: {
      labelText: 'Best offer',
      regularPrice: '$432',
      discountedPrice: '$174',
      discountedPriceCharge: '/year',
      billedText: 'Billed annually',
      countdown: true,
      buttonText: 'Save 60% Now',
      subscribeClass: 'subscribe-annual',
      promoPlanType: 'annual',
    },
    limitedOfferOptions: {
      title: 'Save 60% with Annual Plan',
      promoPlanType: 'annual',
      comparisonPlanType: 'monthly',
      comparisonPlanBilledText: 'Billed Monthly',
      promoPlanBilledText: 'Billed Annually',
      regularPrice: '$432',
      discountedPrice: '$174',
      billedComparisonPrice: '$36',
      discountedPriceCharge: '/year',
      billedComparisonCharge: '/month',
      promoPlanSubscribeClass: 'subscribe-annual',
      comparisonSubscribeClass: 'subscribe-monthly',
      promoPlanButtonText: 'Save 60% Now',
      comparisonPlanButtonText: 'Start Your Career',
    },
    bottomBannerOptions: {
      className: 'upgrade-offer',
      labelText: 'Save 60%',
      title: 'Complete Data Science Training',
      buttonText: 'Get Started',
    },
  },
  'start-learning-0': {
    className: 'start-learning',
    banner: false,
    coupon: 'YT20STL1KAS',
    pagePercentOff: '57%',
    heroSectionOptions: {
      titleHTML: 'Learn Data Science <br> with Top Industry Experts <br> at 57% Off',
      subtitle: '<p>The 365 Data Science Program equips you with the versatile skillset you need to start a career in data science.</p><p>Sign up today at 57% OFF to secure a full year of learning and access all new course releases at no extra cost.</p>',
    },
    promoCardOptions: {
      labelText: 'Best offer',
      regularPrice: '$432',
      discountedPrice: '$184.5',
      discountedPriceCharge: '/year',
      billedText: 'Billed annually',
      countdown: false,
      buttonText: 'Save 57% Now',
      subscribeClass: 'subscribe-annual',
      promoPlanType: 'annual',
    },
    limitedOfferOptions: {
      title: 'Save 57% with Annual Plan',
      promoPlanType: 'annual',
      comparisonPlanType: 'monthly',
      comparisonPlanBilledText: 'Billed Monthly',
      promoPlanBilledText: 'Billed Annually',
      regularPrice: '$432',
      discountedPrice: '$184.50',
      billedComparisonPrice: '$36',
      discountedPriceCharge: '/year',
      billedComparisonCharge: '/month',
      promoPlanSubscribeClass: 'subscribe-annual',
      comparisonSubscribeClass: 'subscribe-monthly',
      promoPlanButtonText: 'Save 57% Now',
      comparisonPlanButtonText: 'Start Your Career',
    },
  },
  'start-learning-1': {
    className: 'start-learning',
    banner: false,
    coupon: 'YT20STL1KAS',
    pagePercentOff: '57%',
    heroSectionOptions: {
      titleHTML: 'Jumpstart Your Data Science Career with Esteemed Experts. Get Full Access at 57% OFF!',
      subtitle: '<p>Become a competitive candidate for an in-demand career! Our data science courses not only provide the comprehensive skillsets needed to excel, but they’re taught by world-class instructors.</p><p><a href="https://365datascience.com/signup/">Sign up today and get 57% OFF</a> our full course catalogue!</p>',
    },
    programStatsOptions: {
      title: 'Maximize Your Career Potential',
      subtitle: 'Are you completely new to data science or looking to advance your skills? In any case, our comprehensive training will guide you from the ground up! From green to gurus, we’ve helped 2+ million students land their dream job!',
    },
    videoTitle: '365 Data Science in a Nutshell',
    industryExpertsHeroSection: {
      title: 'Get Personalized Training from Industry Experts',
      subtitle: '<p>Great instruction makes a world of a difference! Leverage the knowledge, experience, and industry insights of data science experts from world-renowned companies.</p>',
    },
    modulesExtend: {
      // module 1
      0: {
        subtitle: 'This module will help you develop a strong foundation for a data science career. You will start working with data, learning how to analyze and visually represent your results using specialized tools. We also deep-dive into key concepts, including but not limited to probability, statistics, and math specific to building machine and deep learning models (which we cover in Module 3).',
      },
      // module 3
      1: {
        subtitle: 'Module 3 builds on the foundations developed in Modules 1 and 2. We’ll show you advanced statistical methods for executing predictive analytics. From using Sklearn to build complete linear and logistic regression models, to clustering unlabeled datasets with K-means, we cover everything from scratch. We’ll then progress to both building and fine-tuning your deep learning models using the Keras library in TensorFlow 2.0, optimizing your neural network with backpropagation.',
      },
      // module 2
      2: {
        subtitle: 'In this module, you will develop a versatile suite of programming skills. We start by giving you a thorough and functional understanding of relational databases, using SQL queries to pre-process data. We’ll then cover coding and how to use popular libraries in Python like NumPy and Matplotlib. You’ll also learn key tips and tricks for visualizing and manipulating data in R.',
      },
      // module 4
      3: {
        subtitle: 'Given your new-found knowledge of Python programming and statistical modeling, you’re now ready to fine-tune your skills to a field of your choosing. That’s where Module 4 comes in. From using customer analytics to boost the profitability of retail giants, to creating the next generation of fin-tech products, you’re bound to constructively contribute to your company.',
      },
    },
    dataScienceCardsOptions: {
      title: 'Work Smarter, Not Harder',
      subtitle: 'Life is hectic enough without having to invest time and money into a traditional graduate program. That’s why all our 365 Data Science modules are broken down into short micro-learning lessons (between 2-10 minutes). Work around your own schedule while receiving the results you want faster and with less effort!',
      firstCardTitle: 'Career Tracks',
      firstCardText: 'Data Science is a diverse industry spectrum and no one knows your professional goals better than you do. So carve your own career track, choose the electives that best suit your needs, and master highly-sought-after skills!',
      secondCardTitle: 'Self-Paced Online Courses',
      secondCardText: 'Set daily learning goals and blend success into your routine! Whether on your daily commute, during lunch breaks, or just before bed, you’ll have access your video lessons, exercises, and real-world business cases anytime, anywhere.',
      thirdCardTitle: 'In-Platform Resume Builder',
      thirdCardText: 'Not only can you leverage our intuitive resume-building tool to write sharp and effective resumes in minutes, but you can also connect with potential employers from our list of partner companies.',
    },
    programCardTitle: 'Travel Down a Logical Learning Path',
    promoCardOptions: {
      labelText: 'Best offer',
      regularPrice: '$432',
      discountedPrice: '$184.50',
      discountedPriceCharge: '/year',
      billedText: 'Billed annually',
      countdown: false,
      buttonText: 'Save 57% Now',
      subscribeClass: 'subscribe-annual',
      promoPlanType: 'annual',
    },
    trustedTitle: 'Acclaimed by over 2,000,000 students',
    trustedFooterText: 'We’ve empowered students from 210 countries to launch rewarding data science careers.',
    limitedOfferOptions: {
      title: 'Save 57% with Annual Plan',
      promoPlanType: 'annual',
      comparisonPlanType: 'monthly',
      comparisonPlanBilledText: 'Billed Monthly',
      promoPlanBilledText: 'Billed Annually',
      regularPrice: '$432',
      discountedPrice: '$184.50',
      billedComparisonPrice: '$36',
      discountedPriceCharge: '/year',
      billedComparisonCharge: '/month',
      promoPlanSubscribeClass: 'subscribe-annual',
      comparisonSubscribeClass: 'subscribe-monthly',
      promoPlanButtonText: 'Save 57% Now',
      comparisonPlanButtonText: 'Start Your Career',
    },
  },
  'knn-0': {
    className: 'knn',
    banner: false,
    coupon: 'KNN',
    pagePercentOff: '57%',
    heroSectionOptions: {
      titleHTML: 'Learn Data Science <br> with Top Industry Experts <br> at 57% Off',
      subtitle: '<p>The 365 Data Science Program equips you with the versatile skillset you need to start a career in data science.</p><p>Sign up today at 57% OFF to secure a full year of learning and access all new course releases at no extra cost.</p>',
    },
    promoCardOptions: {
      labelText: 'Best offer',
      regularPrice: '$432',
      discountedPrice: '$184.50',
      discountedPriceCharge: '/year',
      billedText: 'Billed annually',
      countdown: false,
      buttonText: 'Save 57% Now',
      subscribeClass: 'subscribe-annual',
      promoPlanType: 'annual',
    },
    limitedOfferOptions: {
      title: 'Save 57% with Annual Plan',
      promoPlanType: 'annual',
      comparisonPlanType: 'monthly',
      comparisonPlanBilledText: 'Billed Monthly',
      promoPlanBilledText: 'Billed Annually',
      regularPrice: '$432',
      discountedPrice: '$184.50',
      billedComparisonPrice: '$36',
      discountedPriceCharge: '/year',
      billedComparisonCharge: '/month',
      promoPlanSubscribeClass: 'subscribe-annual',
      comparisonSubscribeClass: 'subscribe-monthly',
      promoPlanButtonText: 'Save 57% Now',
      comparisonPlanButtonText: 'Start Your Career',
    },
  },
  'knn-1': {
    className: 'knn',
    banner: false,
    coupon: 'KNN',
    pagePercentOff: '57%',
    heroSectionOptions: {
      titleHTML: 'Jumpstart Your Data Science Career with Esteemed Experts. Get Full Access at 57% OFF!',
      subtitle: '<p>Become a competitive candidate for an in-demand career! Our data science courses not only provide the comprehensive skillsets needed to excel, but they’re taught by world-class instructors.</p><p><a href="https://365datascience.com/signup/">Sign up today and get 57% OFF</a> our full course catalogue!</p>',
    },
    programStatsOptions: {
      title: 'Maximize Your Career Potential',
      subtitle: 'Are you completely new to data science or looking to advance your skills? In any case, our comprehensive training will guide you from the ground up! From green to gurus, we’ve helped 2+ million students land their dream job!',
    },
    videoTitle: '365 Data Science in a Nutshell',
    industryExpertsHeroSection: {
      title: 'Get Personalized Training from Industry Experts',
      subtitle: '<p>Great instruction makes a world of a difference! Leverage the knowledge, experience, and industry insights of data science experts from world-renowned companies.</p>',
    },
    modulesExtend: {
      // module 1
      0: {
        subtitle: 'This module will help you develop a strong foundation for a data science career. You will start working with data, learning how to analyze and visually represent your results using specialized tools. We also deep-dive into key concepts, including but not limited to probability, statistics, and math specific to building machine and deep learning models (which we cover in Module 3).',
      },
      // module 3
      1: {
        subtitle: 'Module 3 builds on the foundations developed in Modules 1 and 2. We’ll show you advanced statistical methods for executing predictive analytics. From using Sklearn to build complete linear and logistic regression models, to clustering unlabeled datasets with K-means, we cover everything from scratch. We’ll then progress to both building and fine-tuning your deep learning models using the Keras library in TensorFlow 2.0, optimizing your neural network with backpropagation.',
      },
      // module 2
      2: {
        subtitle: 'In this module, you will develop a versatile suite of programming skills. We start by giving you a thorough and functional understanding of relational databases, using SQL queries to pre-process data. We’ll then cover coding and how to use popular libraries in Python like NumPy and Matplotlib. You’ll also learn key tips and tricks for visualizing and manipulating data in R.',
      },
      // module 4
      3: {
        subtitle: 'Given your new-found knowledge of Python programming and statistical modeling, you’re now ready to fine-tune your skills to a field of your choosing. That’s where Module 4 comes in. From using customer analytics to boost the profitability of retail giants, to creating the next generation of fin-tech products, you’re bound to constructively contribute to your company.',
      },
    },
    dataScienceCardsOptions: {
      title: 'Work Smarter, Not Harder',
      subtitle: 'Life is hectic enough without having to invest time and money into a traditional graduate program. That’s why all our 365 Data Science modules are broken down into short micro-learning lessons (between 2-10 minutes). Work around your own schedule while receiving the results you want faster and with less effort!',
      firstCardTitle: 'Career Tracks',
      firstCardText: 'Data Science is a diverse industry spectrum and no one knows your professional goals better than you do. So carve your own career track, choose the electives that best suit your needs, and master highly-sought-after skills!',
      secondCardTitle: 'Self-Paced Online Courses',
      secondCardText: 'Set daily learning goals and blend success into your routine! Whether on your daily commute, during lunch breaks, or just before bed, you’ll have access your video lessons, exercises, and real-world business cases anytime, anywhere.',
      thirdCardTitle: 'In-Platform Resume Builder',
      thirdCardText: 'Not only can you leverage our intuitive resume-building tool to write sharp and effective resumes in minutes, but you can also connect with potential employers from our list of partner companies.',
    },
    programCardTitle: 'Travel Down a Logical Learning Path',
    promoCardOptions: {
      labelText: 'Best offer',
      regularPrice: '$432',
      discountedPrice: '$184.50',
      discountedPriceCharge: '/year',
      billedText: 'Billed annually',
      countdown: false,
      buttonText: 'Save 57% Now',
      subscribeClass: 'subscribe-annual',
      promoPlanType: 'annual',
    },
    trustedTitle: 'Acclaimed by over 2,000,000 students',
    trustedFooterText: 'We’ve empowered students from 210 countries to launch rewarding data science careers.',
    limitedOfferOptions: {
      title: 'Save 57% with Annual Plan',
      promoPlanType: 'annual',
      comparisonPlanType: 'monthly',
      comparisonPlanBilledText: 'Billed Monthly',
      promoPlanBilledText: 'Billed Annually',
      regularPrice: '$432',
      discountedPrice: '$184.50',
      billedComparisonPrice: '$36',
      discountedPriceCharge: '/year',
      billedComparisonCharge: '/month',
      promoPlanSubscribeClass: 'subscribe-annual',
      comparisonSubscribeClass: 'subscribe-monthly',
      promoPlanButtonText: 'Save 57% Now',
      comparisonPlanButtonText: 'Start Your Career',
    },
  },
  'th-365': {
    className: 'th-365',
    banner: false,
    coupon: 'YTTINA60A',
    pagePercentOff: '60%',
    heroSectionOptions: {
      titleHTML: 'Jumpstart Your Data Science Career with Esteemed Experts. Get Full Access at 60% OFF!',
      subtitle: '<p>Become a competitive candidate for an in-demand career! Our data science courses not only provide the comprehensive skillsets needed to excel, but they’re taught by world-class instructors.</p><p><a href="https://365datascience.com/signup/">Sign up today and get 60% OFF</a> our full course catalogue!</p>',
    },
    programStatsOptions: {
      title: 'Maximize Your Career Potential',
      subtitle: 'Are you completely new to data science or looking to advance your skills? In any case, our comprehensive training will guide you from the ground up! From green to gurus, we’ve helped 2+ million students land their dream job!',
    },
    videoTitle: '365 Data Science in a Nutshell',
    industryExpertsHeroSection: {
      title: 'Get Personalized Training from Industry Experts',
      subtitle: '<p>Great instruction makes a world of a difference! Leverage the knowledge, experience, and industry insights of data science experts from world-renowned companies.</p>',
    },
    modulesExtend: {
      // module 1
      0: {
        subtitle: 'This module will help you develop a strong foundation for a data science career. You will start working with data, learning how to analyze and visually represent your results using specialized tools. We also deep-dive into key concepts, including but not limited to probability, statistics, and math specific to building machine and deep learning models (which we cover in Module 3).',
      },
      // module 3
      1: {
        subtitle: 'Module 3 builds on the foundations developed in Modules 1 and 2. We’ll show you advanced statistical methods for executing predictive analytics. From using Sklearn to build complete linear and logistic regression models, to clustering unlabeled datasets with K-means, we cover everything from scratch. We’ll then progress to both building and fine-tuning your deep learning models using the Keras library in TensorFlow 2.0, optimizing your neural network with backpropagation.',
      },
      // module 2
      2: {
        subtitle: 'In this module, you will develop a versatile suite of programming skills. We start by giving you a thorough and functional understanding of relational databases, using SQL queries to pre-process data. We’ll then cover coding and how to use popular libraries in Python like NumPy and Matplotlib. You’ll also learn key tips and tricks for visualizing and manipulating data in R.',
      },
      // module 4
      3: {
        subtitle: 'Given your new-found knowledge of Python programming and statistical modeling, you’re now ready to fine-tune your skills to a field of your choosing. That’s where Module 4 comes in. From using customer analytics to boost the profitability of retail giants, to creating the next generation of fin-tech products, you’re bound to constructively contribute to your company.',
      },
    },
    dataScienceCardsOptions: {
      title: 'Work Smarter, Not Harder',
      subtitle: 'Life is hectic enough without having to invest time and money into a traditional graduate program. That’s why all our 365 Data Science modules are broken down into short micro-learning lessons (between 2-10 minutes). Work around your own schedule while receiving the results you want faster and with less effort!',
      firstCardTitle: 'Career Tracks',
      firstCardText: 'Data Science is a diverse industry spectrum and no one knows your professional goals better than you do. So carve your own career track, choose the electives that best suit your needs, and master highly-sought-after skills!',
      secondCardTitle: 'Self-Paced Online Courses',
      secondCardText: 'Set daily learning goals and blend success into your routine! Whether on your daily commute, during lunch breaks, or just before bed, you’ll have access your video lessons, exercises, and real-world business cases anytime, anywhere.',
      thirdCardTitle: 'In-Platform Resume Builder',
      thirdCardText: 'Not only can you leverage our intuitive resume-building tool to write sharp and effective resumes in minutes, but you can also connect with potential employers from our list of partner companies.',
    },
    programCardTitle: 'Travel Down a Logical Learning Path',
    promoCardOptions: {
      labelText: 'Best offer',
      regularPrice: '$432',
      discountedPrice: '$174',
      discountedPriceCharge: '/year',
      billedText: 'Billed annually',
      countdown: false,
      buttonText: 'Save 60% Now',
      subscribeClass: 'subscribe-annual',
      promoPlanType: 'annual',
    },
    trustedTitle: 'Acclaimed by over 2,000,000 students',
    trustedFooterText: 'We’ve empowered students from 210 countries to launch rewarding data science careers.',
    limitedOfferOptions: {
      title: 'Save 60% with Annual Plan',
      promoPlanType: 'annual',
      comparisonPlanType: 'monthly',
      comparisonPlanBilledText: 'Billed Monthly',
      promoPlanBilledText: 'Billed Annually',
      regularPrice: '$432',
      discountedPrice: '$174',
      billedComparisonPrice: '$36',
      discountedPriceCharge: '/year',
      billedComparisonCharge: '/month',
      promoPlanSubscribeClass: 'subscribe-annual',
      comparisonSubscribeClass: 'subscribe-monthly',
      promoPlanButtonText: 'Save 60% Now',
      comparisonPlanButtonText: 'Start Your Career',
    },
  },
  'resources-centeroffer-0': {
    className: 'resources-center-offer',
    banner: false,
    coupon: '365RESOURCES',
    pagePercentOff: '60%',
    videoInHero: false,
    background: {
      default: 'landing-page-resources-bg.jpg',
      mobile: 'landing-page-resources-mobile-bg.jpg',
    },
    heroSectionOptions: {
      titleHTML: 'Learn Data Science Online at 60% Off',
      subtitle: `<p>Follow in the footsteps of successful data professionals.<br><br>
                        Build the must-have skills for your career development and growth – from data visualization and programming to advanced machine learning and business analytics techniques.<br><br>
                        Right now, for just $172.80 with 30-day money-back guarantee. </p>`,
      companiesRow: true,
    },
    promoCardOptions: {
      labelText: 'Exclusive offer',
      regularPrice: '$432',
      discountedPrice: '$172.80',
      discountedPriceCharge: '/year',
      billedText: 'Billed annually',
      countdown: false,
      buttonText: 'Save 60% Now',
      subscribeClass: 'subscribe-annual',
      promoPlanType: 'annual',
    },
    limitedOfferOptions: {
      title: 'Take Your Data Skills to the Next Level',
      promoPlanType: 'annual',
      comparisonPlanType: 'monthly',
      comparisonPlanBilledText: 'Billed Monthly',
      promoPlanBilledText: 'Billed Annually',
      regularPrice: '$432',
      discountedPrice: '$172.80',
      billedComparisonPrice: '$36',
      discountedPriceCharge: '/year',
      billedComparisonCharge: '/month',
      promoPlanSubscribeClass: 'subscribe-annual',
      comparisonSubscribeClass: 'subscribe-monthly',
      promoPlanButtonText: 'Save 60% Now',
      comparisonPlanButtonText: 'Start Your Career',
    },
    limitedOfferFeatures: [
      {
        name: 'World-class instructors',
      },
      {
        name: 'Monthly content updates',
      },
      {
        name: '160+ hours of video',
      },
      {
        name: 'Business cases',
      },
      {
        name: '560+ exercises',
      },
      {
        name: 'Downloadable resources',
      },
      {
        name: 'Career tracks',
      },
      {
        name: 'Resume builder',
      },
      {
        name: 'Exams',
      },
      {
        name: 'Personalized support',
      },
      {
        name: 'Certificates',
      },
      {
        name: 'Real-world projects',
      },
      {
        name: 'Self-paced lessons',
      },
      {
        name: '30-day refund',
      },
    ],
    dataScienceCardsOptions: {
      title: 'Accomplish Your Goals with Ease',
      subtitle: 'Your success is our priority. The 365 Data Science Program is designed to fit your busy schedule and help you achieve the results you want faster and with less effort than any traditional graduate program.',
      firstCardTitle: 'Choose a Career Track',
      firstCardText: 'Мaster the skills for the specific job role you want – Data Scientist, Data Analyst, or Business Analyst. Each career track consists of 1 optional course, 7 required courses, and 2 electives. Structured in a sequence, every course builds on what you have learned from the previous one.',
      secondCardTitle: 'Build Data Skills with Self-paced Online Courses ',
      secondCardText: 'Enjoy the flexibility of online learning. Access your video lessons, exercises, and real-world business cases anytime, anywhere. Set your daily learning goals and make success a routine.',
      thirdCardTitle: 'Learn with World-Class Instructors',
      thirdCardText: 'Our courses are created by top professionals who have held high-level positions in companies like Google, Henkel, Coca-Cola, and New York Life Insurance. They will help you achieve the results you want regardless of your background and starting level.',
      fourthCardTitle: 'Validate Your Skills with Exams',
      fourthCardText: 'Exams prove you meet a high standard of competence and demonstrate your abilities to employers. You can test the skills you have acquired with 3 types of timed exams – Practice Exams, Course Exams, and Career Track Exams.',
      fifthCardTitle: 'Gain a Competitive Edge with Certificates',
      fifthCardText: 'Passing the necessary exams makes you eligible for Course Certificates or a Career Track Certificate. Both official credentials are widely recognized by industry professionals, confirm your domain expertise and demonstrate you are job-ready.',
      sixthCardTitle: 'Create a Job-Winning Resume',
      sixthCardText: 'With our in-platform Resume Builder, you can write a sharp and effective resume in minutes and get contacted directly by high-profile employers looking for their next hire.',
      dark: true,
    },
    trustedTitle: 'Trusted by over 2,000,000 students',
    programStatsOptions: false,
    programCardsButton: { text: 'Start Learning at 60% Off', link: '' },
    industryExpertsHeroSection: false,
    videoSource: '6307571212112',
  },
  'resources-centeroffer-1': {
    className: 'resources-center-offer',
    banner: false,
    coupon: '365RESOURCES',
    pagePercentOff: '60%',
    videoInHero: true,
    background: {
      default: 'landing-page-resources-bg.jpg',
      mobile: 'landing-page-resources-mobile-bg.jpg',

    },
    heroSectionOptions: {
      titleHTML: 'Learn Data Science Online at 60% Off',
      subtitle: `<p>Follow in the footsteps of successful data professionals.<br><br>
                        Build the must-have skills for your career development and growth – from data visualization and programming to advanced machine learning and business analytics techniques.<br><br>
                        Right now, for just $172.80 with 30-day money-back guarantee. </p>`,
      companiesRow: true,
    },
    promoCardOptions: {
      labelText: 'Exclusive offer',
      regularPrice: '$432',
      discountedPrice: '$172.80',
      discountedPriceCharge: '/year',
      billedText: 'Billed annually',
      countdown: false,
      buttonText: 'Save 60% Now',
      subscribeClass: 'subscribe-annual',
      promoPlanType: 'annual',
    },
    limitedOfferOptions: {
      title: 'Take Your Data Skills to the Next Level',
      promoPlanType: 'annual',
      comparisonPlanType: 'monthly',
      comparisonPlanBilledText: 'Billed Monthly',
      promoPlanBilledText: 'Billed Annually',
      regularPrice: '$432',
      discountedPrice: '$172.80',
      billedComparisonPrice: '$36',
      discountedPriceCharge: '/year',
      billedComparisonCharge: '/month',
      promoPlanSubscribeClass: 'subscribe-annual',
      comparisonSubscribeClass: 'subscribe-monthly',
      promoPlanButtonText: 'Save 60% Now',
      comparisonPlanButtonText: 'Start Your Career',
    },
    limitedOfferFeatures: [
      {
        name: 'World-class instructors',
      },
      {
        name: 'Monthly content updates',
      },
      {
        name: '160+ hours of video',
      },
      {
        name: 'Business cases',
      },
      {
        name: '560+ exercises',
      },
      {
        name: 'Downloadable resources',
      },
      {
        name: 'Career tracks',
      },
      {
        name: 'Resume builder',
      },
      {
        name: 'Exams',
      },
      {
        name: 'Personalized support',
      },
      {
        name: 'Certificates',
      },
      {
        name: 'Real-world projects',
      },
      {
        name: 'Self-paced lessons',
      },
      {
        name: '30-day refund',
      },
    ],
    dataScienceCardsOptions: {
      title: 'Accomplish Your Goals with Ease',
      subtitle: 'Your success is our priority. The 365 Data Science Program is designed to fit your busy schedule and help you achieve the results you want faster and with less effort than any traditional graduate program.',
      firstCardTitle: 'Choose a Career Track',
      firstCardText: 'Мaster the skills for the specific job role you want – Data Scientist, Data Analyst, or Business Analyst. Each career track consists of 1 optional course, 7 required courses, and 2 electives. Structured in a sequence, every course builds on what you have learned from the previous one.',
      secondCardTitle: 'Build Data Skills with Self-paced Online Courses ',
      secondCardText: 'Enjoy the flexibility of online learning. Access your video lessons, exercises, and real-world business cases anytime, anywhere. Set your daily learning goals and make success a routine.',
      thirdCardTitle: 'Learn with World-Class Instructors',
      thirdCardText: 'Our courses are created by top professionals who have held high-level positions in companies like Google, Henkel, Coca-Cola, and New York Life Insurance. They will help you achieve the results you want regardless of your background and starting level.',
      fourthCardTitle: 'Validate Your Skills with Exams',
      fourthCardText: 'Exams prove you meet a high standard of competence and demonstrate your abilities to employers. You can test the skills you have acquired with 3 types of timed exams – Practice Exams, Course Exams, and Career Track Exams.',
      fifthCardTitle: 'Gain a Competitive Edge with Certificates',
      fifthCardText: 'Passing the necessary exams makes you eligible for Course Certificates or a Career Track Certificate. Both official credentials are widely recognized by industry professionals, confirm your domain expertise and demonstrate you are job-ready.',
      sixthCardTitle: 'Create a Job-Winning Resume',
      sixthCardText: 'With our in-platform Resume Builder, you can write a sharp and effective resume in minutes and get contacted directly by high-profile employers looking for their next hire.',
      dark: true,
    },
    trustedTitle: 'Trusted by over 2,000,000 students',
    programStatsOptions: false,
    programCardsButton: { text: 'Start Learning at 60% Off', link: '' },
    industryExpertsHeroSection: false,
    videoSource: '6307571212112',
  },
  'start-learning-m': {
    className: 'start-learning-m',
    banner: false,
    coupon: 'MRXG9BF',
    pagePercentOff: '25%',
    heroSectionOptions: {
      titleHTML: 'Learn Data Science <br> with Top Industry Experts <br> at 25% Off',
      subtitle: '<p>The 365 Data Science Program equips you with the versatile skillset you need to start a career in data science.</p><p>Sign up today at 25% OFF to secure a full month of unlimited access to all our courses.</p>',
    },
    promoCardOptions: {
      labelText: 'Best offer',
      regularPrice: '$36',
      discountedPrice: '$27',
      discountedPriceCharge: '/monthly',
      billedText: 'Billed monthly',
      countdown: false,
      buttonText: 'Save 25% Now',
      subscribeClass: 'subscribe-monthly',
      promoPlanType: 'monthly',
    },
    limitedOfferOptions: {
      title: 'Save 25% with Monthly Plan',
      promoPlanType: 'monthly',
      comparisonPlanType: 'annual',
      comparisonPlanBilledText: 'Billed Annually',
      promoPlanBilledText: 'Billed Monthly',
      regularPrice: '$36',
      discountedPrice: '$27',
      billedComparisonPrice: '$432',
      discountedPriceCharge: '/month',
      billedComparisonCharge: '/year',
      promoPlanSubscribeClass: 'subscribe-monthly',
      comparisonSubscribeClass: 'subscribe-annual',
      promoPlanButtonText: 'Save 25% Now',
      comparisonPlanButtonText: 'Start Your Career',
    },
  },
  'start-learning-l': {
    className: 'start-learning-l',
    banner: false,
    coupon: 'AVQSIQD',
    pagePercentOff: '70%',
    heroSectionOptions: {
      titleHTML: 'Learn Data Science <br> with Top Industry Experts <br> at 70% Off',
      subtitle: '<p>The 365 Data Science Program equips you with the versatile skillset you need to start a career in data science.</p><p>Sign up today at 70% OFF to secure lifetime access to the complete training plus all new course releases at no extra cost.</p>',
    },
    promoCardOptions: {
      labelText: 'Best offer',
      regularPrice: '$800',
      discountedPrice: '$240',
      discountedPriceCharge: '/one time',
      billedText: 'Billed one time',
      countdown: false,
      buttonText: 'Save 70% Now',
      subscribeClass: 'subscribe-lifetime',
      promoPlanType: 'lifetime',
    },
    limitedOfferOptions: {
      title: 'Save 70% with Lifetime Plan',
      promoPlanType: 'lifetime',
      comparisonPlanType: 'monthly',
      comparisonPlanBilledText: 'Billed Monthly',
      promoPlanBilledText: 'Billed One Time',
      regularPrice: '$800',
      discountedPrice: '$240',
      billedComparisonPrice: '$36',
      discountedPriceCharge: '/one time',
      billedComparisonCharge: '/month',
      promoPlanSubscribeClass: 'subscribe-lifetime',
      comparisonSubscribeClass: 'subscribe-monthly',
      promoPlanButtonText: 'Save 70% Now',
      comparisonPlanButtonText: 'Start Your Career',
    },
  },
  'webinar-special-offer': {
    className: 'webinar-special-offer',
    banner: false,
    coupon: 'YT_WEB_03',
    pagePercentOff: '75%',
    heroSectionOptions: {
      titleHTML: 'Learn Data Science <br> with Top Industry Experts <br> at 75% Off',
      subtitle: '<p>The 365 Data Science Program equips you with the versatile skillset you need to start a career in data science.</p><p>Sign up today at 75% OFF to secure lifetime access to the complete training plus all new course releases at no extra cost.</p>',
    },
    promoCardOptions: {
      labelText: 'Best offer',
      regularPrice: '$800',
      discountedPrice: '$200',
      discountedPriceCharge: '/one time',
      billedText: 'Billed one time',
      countdown: false,
      buttonText: 'Save 75% Now',
      subscribeClass: 'subscribe-lifetime',
      promoPlanType: 'lifetime',
    },
    limitedOfferOptions: {
      title: 'Save 75% with Lifetime Plan',
      promoPlanType: 'lifetime',
      comparisonPlanType: 'monthly',
      comparisonPlanBilledText: 'Billed Monthly',
      promoPlanBilledText: 'Billed One Time',
      regularPrice: '$800',
      discountedPrice: '$200',
      billedComparisonPrice: '$36',
      discountedPriceCharge: '/one time',
      billedComparisonCharge: '/month',
      promoPlanSubscribeClass: 'subscribe-lifetime',
      comparisonSubscribeClass: 'subscribe-monthly',
      promoPlanButtonText: 'Save 75% Now',
      comparisonPlanButtonText: 'Start Your Career',
    },
  },
};

export const FA_PAGES = {
  'resources-centeroffer-0': {
    banner: false,
    className: 'resources-center-offer',
    coupon: '365RESOURCES',
    pagePercentOff: '60%',
    videoInHero: false,
    heroSectionOptions: {
      titleHTML: 'Learn Finance Online at 60% Off',
      subtitle: `<p>Follow in the footsteps of successful finance professionals.<br><br>
                Build the must-have skills for your career development and growth – from financial reporting and accounting to advanced financial analysis and modeling techniques.<br><br>
                Only now available for just $172.80/year with a 30-day money-back guarantee.</p>`,
      companiesRow: true,
    },
    modulesExtend: {
      // module 1
      0: {
        subtitle: 'Learn everything you need to build a successful financial analysis career. Acquire robust accounting, financial planning, analysis, and reporting skills.',
      },
      // module 3
      1: {
        subtitle: 'Prepare for this demanding career by learning financial modeling, investment banking, and corporate finance.',
      },
      // module 2
      2: {
        subtitle: 'Gain the skills to research and assess potential investment opportunities and become a sought-after investment analyst or associate.',
      },
    },
    promoCardOptions: {
      labelText: 'Exclusive offer',
      regularPrice: '$432',
      discountedPrice: '$172.80',
      discountedPriceCharge: '/year',
      billedText: 'Billed annually',
      countdown: false,
      buttonText: 'Save 60% Now',
      subscribeClass: 'subscribe-annual',
      promoPlanType: 'annual',
    },
    limitedOfferOptions: {
      title: 'Take Your Finance Skills To The Next Level',
      promoPlanType: 'annual',
      comparisonPlanType: 'monthly',
      comparisonPlanBilledText: 'Billed Monthly',
      promoPlanBilledText: 'Billed Annually',
      regularPrice: '$432',
      discountedPrice: '$172.80',
      billedComparisonPrice: '$36',
      discountedPriceCharge: '/year',
      billedComparisonCharge: '/month',
      promoPlanSubscribeClass: 'subscribe-annual',
      comparisonSubscribeClass: 'subscribe-monthly',
      promoPlanButtonText: 'Save 60% Now',
      comparisonPlanButtonText: 'Start Your Career',
    },
    limitedOfferFeatures: [
      {
        name: 'World-class instructors',
      },
      {
        name: 'Industry-recognized certificates',
      },
      {
        name: 'Engaging video lessons',
      },
      {
        name: 'Monthly content updates',
      },
      {
        name: 'Hands-on exercises',
      },
      {
        name: 'Downloadable resources',
      },
      {
        name: 'Case studies',
      },
      {
        name: 'Resume builder',
      },
      {
        name: 'Self-paced lessons',
      },
      {
        name: 'Personalized support',
      },
      {
        name: 'Career tracks',
      },
      {
        name: '30-day refund',
      },
      {
        name: 'Exams',
      },
    ],
    dataScienceCardsOptions: {
      title: 'Accomplish Your Goals with Ease',
      subtitle: 'Your success is our priority. The 365 Financial Analyst program is designed to fit your busy schedule and help you achieve the results you want faster and with less effort than any traditional graduate program.',
      firstCardTitle: 'Choose a Career Track',
      firstCardText: 'Master the skills for your desired career—financial analyst, investment banker, or investment analyst. Each career track comprises one optional, seven required, and two elective courses. Structured in a logical sequence, every course builds on the previous one.',
      secondCardTitle: 'Build Finance Skills with Self-Paced Online Courses',
      secondCardText: 'Enjoy the flexibility of online learning. Access your video lessons, exercises, and real-world business cases anytime, anywhere. Set your daily learning goals and make success a routine.',
      thirdCardTitle: 'Learn with World-Class Instructors',
      thirdCardText: 'Our courses are created by top professionals with vast experience in their fields of expertise. They will help you achieve the results you want regardless of your background and starting level.',
      fourthCardTitle: 'Validate Your Skills with Exams',
      fourthCardText: 'Exams prove your competence and abilities to employers. You can test the skills you have acquired with three types of timed exams: practice, course, and career track exams.',
      fifthCardTitle: 'Gain a Competitive Edge with Certificates',
      fifthCardText: 'Pass the necessary exams to obtain a course or career track certificate. The official 365 Financial Analyst credentials are widely recognized by industry professionals, confirm your domain expertise, and demonstrate you are job-ready.',
      sixthCardTitle: 'Create a Job-Winning Resume',
      sixthCardText: 'With our in-platform resume builder, you can write a sharp and effective resume in minutes. Impress high-profile employers and increase your chances of getting hired.',
      dark: true,
    },
    trustedTitle: 'Trusted by over 2,000,000 students',
    trustedFooterText: 'We’ve helped students from 210 countries worldwide advance their finance careers.',
    programStatsOptions: false,
    programCardsButton: { text: 'Start Learning at 60% Off', link: '' },
    industryExpertsHeroSection: false,
    videoSource: '6307571212112',
  },
  'start-learning-m': {
    banner: false,
    coupon: 'MRXG9BF',
    className: 'start-learning-m',
    pagePercentOff: '25%',
    heroSectionOptions: {
      titleHTML: 'Learn Finance with Top<br> Industry Experts at 25% OFF',
      subtitle: '<p>The 365 Financial Analyst program equips you with the versatile skillset you need to start a career in data science.</p><p>Sign up today at 25% OFF to secure a full month of unlimited access to all our courses.</p>',
    },
    programStatsOptions: {
      title: 'Learn Finance at Your Pace',
      subtitle: 'Our comprehensive training has helped people from all backgrounds and levels of experience land their dream job. Advance your career step by step.',
    },
    dataScienceCardsOptions: {
      title: 'Accomplish Your Goals with Ease',
      subtitle: 'Your success is our priority. The 365 Financial Analyst program is designed to fit your busy schedule and help you achieve the results you want faster and with less effort than any traditional graduate program.',
      firstCardTitle: 'Structured Career Tracks',
      firstCardText: 'You set the path that best suits your professional goals. Master highly sought-after skills, pick the electives to make you stand out, ace the exams, and advance your finance career.',
      secondCardTitle: 'Self-paced Online Courses',
      secondCardText: 'Access your video lessons, exercises, and real-world business cases anytime, anywhere. Set your daily learning goals and make success a routine.',
      thirdCardTitle: 'In-Platform Resume Builder',
      thirdCardText: 'Our in-platform resume builder helps you write a sharp and effective resume in minutes and connect with high-profile employers from our list of partner companies.',
      dark: true,
    },
    promoCardOptions: {
      labelText: 'Best offer',
      regularPrice: '$36',
      discountedPrice: '$27',
      discountedPriceCharge: '/month',
      billedText: 'Billed monthly',
      countdown: false,
      buttonText: 'Save 25% Now',
      subscribeClass: 'subscribe-monthly',
      promoPlanType: 'monthly',
    },
    limitedOfferOptions: {
      title: 'Save 25% with a Monthly Plan',
      promoPlanType: 'monthly',
      comparisonPlanType: 'annual',
      comparisonPlanBilledText: 'Billed Annually',
      promoPlanBilledText: 'Billed Monthly',
      regularPrice: '$36',
      discountedPrice: '$27',
      billedComparisonPrice: '$432',
      discountedPriceCharge: '/month',
      billedComparisonCharge: '/year',
      promoPlanSubscribeClass: 'subscribe-monthly',
      comparisonSubscribeClass: 'subscribe-annual',
      promoPlanButtonText: 'Save 25% Now',
      comparisonPlanButtonText: 'Start Your Career',
    },
    modulesExtend: {
      // module 1
      0: {
        subtitle: 'Learn everything you need to build a successful financial analysis career. Acquire robust accounting, financial planning, analysis, and reporting skills.',
      },
      // module 3
      1: {
        subtitle: 'Gain the skills to research and assess potential investment opportunities and become a sought-after investment analyst or associate.',
      },
      // module 2
      2: {
        subtitle: 'Prepare for this demanding career by learning financial modeling, investment banking, and corporate finance. ',
      },
    },
    limitedOfferFeatures: [
      {
        name: 'World-class instructors',
      },
      {
        name: 'Exams',
      },
      {
        name: 'New content',
      },
      {
        name: 'Resume builder',
      },
      {
        name: 'Engaging video lessons',
      },
      {
        name: 'Industry-recognized certificates',
      },
      {
        name: 'Hands-on exercises',
      },
      {
        name: 'Personalized support',
      },
      {
        name: 'Career tracks',
      },
      {
        name: 'Self-paced lessons',
      },
      {
        name: 'Downloadable resources',
      },
      {
        name: '30-day refund',
      },
    ],
    trustedTitle: 'Trusted by Over 2,000,000 Students',
    trustedFooterText: 'We’ve helped students from 210 countries worldwide advance their careers.',
  },
  'start-learning-l': {
    banner: false,
    coupon: 'AVQSIQD',
    className: 'start-learning-l',
    pagePercentOff: '70%',
    heroSectionOptions: {
      titleHTML: 'Learn Finance with Top<br> Industry Experts at 70% OFF',
      subtitle: '<p>The 365 Financial Analyst program equips you with the versatile skillset you need to start a career in data science.</p><p>Sign up today at 70% OFF to secure a full month of unlimited access to all our courses.</p>',
    },
    programStatsOptions: {
      title: 'Learn Finance at Your Pace',
      subtitle: 'Our comprehensive training has helped people from all backgrounds and levels of experience land their dream job. Advance your career step by step.',
    },
    dataScienceCardsOptions: {
      title: 'Accomplish Your Goals with Ease',
      subtitle: 'Your success is our priority. The 365 Financial Analyst program is designed to fit your busy schedule and help you achieve the results you want faster and with less effort than any traditional graduate program.',
      firstCardTitle: 'Structured Career Tracks',
      firstCardText: 'You set the path that best suits your professional goals. Master highly sought-after skills, pick the electives to make you stand out, ace the exams, and advance your finance career.',
      secondCardTitle: 'Self-paced Online Courses',
      secondCardText: 'Access your video lessons, exercises, and real-world business cases anytime, anywhere. Set your daily learning goals and make success a routine.',
      thirdCardTitle: 'In-Platform Resume Builder',
      thirdCardText: 'Our in-platform resume builder helps you write a sharp and effective resume in minutes and connect with high-profile employers from our list of partner companies.',
      dark: true,
    },
    promoCardOptions: {
      labelText: 'Best offer',
      regularPrice: '$800',
      discountedPrice: '$240',
      discountedPriceCharge: '/one time',
      billedText: 'Billed one time',
      countdown: false,
      buttonText: 'Save 70% Now',
      subscribeClass: 'subscribe-lifetime',
      promoPlanType: 'lifetime',
    },
    limitedOfferOptions: {
      title: 'Save 70% with Lifetime Plan',
      promoPlanType: 'lifetime',
      comparisonPlanType: 'monthly',
      comparisonPlanBilledText: 'Billed Monthly',
      promoPlanBilledText: 'Billed One Time',
      regularPrice: '$800',
      discountedPrice: '$240',
      billedComparisonPrice: '$36',
      discountedPriceCharge: '/one time',
      billedComparisonCharge: '/month',
      promoPlanSubscribeClass: 'subscribe-lifetime',
      comparisonSubscribeClass: 'subscribe-monthly',
      promoPlanButtonText: 'Save 70% Now',
      comparisonPlanButtonText: 'Start Your Career',
    },
    modulesExtend: {
      // module 1
      0: {
        subtitle: 'Learn everything you need to build a successful financial analysis career. Acquire robust accounting, financial planning, analysis, and reporting skills.',
      },
      // module 3
      1: {
        subtitle: 'Gain the skills to research and assess potential investment opportunities and become a sought-after investment analyst or associate.',
      },
      // module 2
      2: {
        subtitle: 'Prepare for this demanding career by learning financial modeling, investment banking, and corporate finance. ',
      },
    },
    limitedOfferFeatures: [
      {
        name: 'World-class instructors',
      },
      {
        name: 'Exams',
      },
      {
        name: 'New content',
      },
      {
        name: 'Resume builder',
      },
      {
        name: 'Engaging video lessons',
      },
      {
        name: 'Industry-recognized certificates',
      },
      {
        name: 'Hands-on exercises',
      },
      {
        name: 'Personalized support',
      },
      {
        name: 'Career tracks',
      },
      {
        name: 'Self-paced lessons',
      },
      {
        name: 'Downloadable resources',
      },
      {
        name: '30-day refund',
      },
    ],
    trustedTitle: 'Trusted by Over 2,000,000 Students',
    trustedFooterText: 'We’ve helped students from 210 countries worldwide advance their careers.',
  },
  'upgrade-offer': {
    banner: true,
    coupon: 'WE21ZE',
    className: 'upgrade-offer',
    pagePercentOff: '60%',
    offerEndDate: true,
    heroSectionOptions: {
      titleHTML: 'Get Full Access to All 365 <br> Financial Analyst Courses <br> at 60% Off',
      subtitle: '<p>Learn the finance skills that will take your career to the next level.</p><p>Upgrade to a premium plan and save 60% with our limited-time offer.</p>',
    },
    programStatsOptions: {
      title: 'Increase Your Finance Career Prospects',
      subtitle: 'Our comprehensive training has helped people from all backgrounds and levels of experience land their dream job. Advance your career step by step.',
    },
    modulesExtend: {
      // module 1
      0: {
        subtitle: 'Learn everything you need to build a successful financial analysis career. Acquire robust accounting, financial planning, analysis, and reporting skills.',
      },
      // module 3
      1: {
        subtitle: 'Gain the skills to research and assess potential investment opportunities and become a sought-after investment analyst or associate.',
      },
      // module 2
      2: {
        subtitle: 'Prepare for this demanding career by learning financial modeling, investment banking, and corporate finance. ',
      },
    },
    dataScienceCardsOptions: {
      title: 'Accomplish Your Goals with Ease',
      subtitle: 'Your success is our priority. The 365 Financial Analyst program is designed to fit your busy schedule and help you achieve the results you want faster and with less effort than any traditional graduate program.',
      firstCardTitle: 'Structured Career Tracks',
      firstCardText: 'You set the path that best suits your professional goals. Master highly sought-after skills, pick the electives to make you stand out, ace the exams, and advance your finance career.',
      secondCardTitle: 'Self-paced Online Courses',
      secondCardText: 'Access your video lessons, exercises, and real-world business cases anytime, anywhere. Set your daily learning goals and make success a routine.',
      thirdCardTitle: 'In-Platform Resume Builder',
      thirdCardText: 'Our in-platform resume builder helps you write a sharp and effective resume in minutes and connect with high-profile employers from our list of partner companies.',
      dark: true,
    },
    promoCardOptions: {
      labelText: 'Best offer',
      regularPrice: '$432',
      discountedPrice: '$174',
      discountedPriceCharge: '/year',
      billedText: 'Billed annually',
      countdown: true,
      buttonText: 'Save 60% Now',
      subscribeClass: 'subscribe-annual',
      promoPlanType: 'annual',
    },
    limitedOfferOptions: {
      title: 'Save 60% with Annual Plan',
      promoPlanType: 'annual',
      comparisonPlanType: 'monthly',
      comparisonPlanBilledText: 'Billed Monthly',
      promoPlanBilledText: 'Billed Annually',
      regularPrice: '$432',
      discountedPrice: '$174',
      billedComparisonPrice: '$36',
      discountedPriceCharge: '/year',
      billedComparisonCharge: '/month',
      promoPlanSubscribeClass: 'subscribe-annual',
      comparisonSubscribeClass: 'subscribe-monthly',
      promoPlanButtonText: 'Save 60% Now',
      comparisonPlanButtonText: 'Start Your Career',
    },
    limitedOfferFeatures: [
      {
        name: 'World-class instructors',
      },
      {
        name: 'Exams',
      },
      {
        name: 'New content',
      },
      {
        name: 'Resume builder',
      },
      {
        name: 'Engaging video lessons',
      },
      {
        name: 'Industry-recognized certificates',
      },
      {
        name: 'Hands-on exercises',
      },
      {
        name: 'Personalized support',
      },
      {
        name: 'Career tracks',
      },
      {
        name: 'Self-paced lessons',
      },
      {
        name: 'Downloadable resources',
      },
      {
        name: '30-day refund',
      },
    ],
    trustedTitle: 'Trusted by Over 2,000,000 Students',
    trustedFooterText: 'We’ve helped students from 210 countries worldwide advance their careers.',
    bottomBannerOptions: {
      className: 'upgrade-offer',
      labelText: 'Save 60%',
      title: 'Complete Financial Training Program',
      buttonText: 'Get Started',
    },
  },
  'start-learning': {
    banner: false,
    coupon: 'YT20STL1KAS',
    className: 'start-learning',
    pagePercentOff: '57%',
    heroSectionOptions: {
      titleHTML: 'Advance Your Finance Career with Esteemed Experts. Get Full Access at 57% OFF!',
      subtitle: '<p>Follow in the footsteps of successful finance professionals.</p><p>Build the must-have skills for your career advancement and growth—from financial statement analysis and reporting to advanced modeling and technical analysis techniques.</p><p><span class="highlighted">Sign up today and get 57% OFF</span> our full course catalog!</p>',
    },
    programCardTitle: 'Travel Down a Logical Learning Path',
    promoCardOptions: {
      labelText: 'Best offer',
      regularPrice: '$432',
      discountedPrice: '$184.44',
      discountedPriceCharge: '/year',
      billedText: 'Billed annually',
      countdown: false,
      buttonText: 'Save 57% Now',
      subscribeClass: 'subscribe-annual',
      promoPlanType: 'annual',
    },
    programStatsOptions: {
      title: 'Maximize Your Career Potential',
      subtitle: 'Are you completely new to finance or looking to advance your skills? In any case, our comprehensive training will help you become a sought-after professional. From green to gurus, we’ve helped 2+ million students land their dream job!',
    },
    modulesExtend: {
      // module 1
      0: {
        subtitle: 'Learn everything you need to build a successful financial analysis career. Acquire robust accounting, financial planning, analysis, and reporting skills.',
      },
      // module 3
      1: {
        subtitle: 'Gain the skills to research and assess potential investment opportunities and become a sought-after investment analyst or associate.',
      },
      // module 2
      2: {
        subtitle: 'Prepare for this demanding career by learning financial modeling, investment banking, and corporate finance. ',
      },
    },
    dataScienceCardsOptions: {
      title: 'Work Smarter, Not Harder',
      subtitle: 'Life is hectic enough without having to invest time and money into a traditional graduate program. That’s why all 365 Financial Analyst courses are broken down into short micro-learning lessons (2–10 minutes). Work around your schedule and achieve your goals step by step.',
      firstCardTitle: 'Structured Career Tracks',
      firstCardText: 'You set the path that best suits your professional goals. Master highly sought-after skills, pick the electives to make you stand out, ace the exams, and advance your finance career.',
      secondCardTitle: 'Self-paced Online Courses',
      secondCardText: 'Access your video lessons, exercises, and real-world business cases anytime, anywhere. Set your daily learning goals and make success a routine.',
      thirdCardTitle: 'In-Platform Resume Builder',
      thirdCardText: 'Our in-platform resume builder helps you write a sharp and effective resume in minutes and connect with high-profile employers from our list of partner companies.',
      dark: true,
    },
    trustedTitle: 'Acclaimed by Over 2,000,000 Students',
    trustedFooterText: 'We’ve empowered students from 210 countries to advance their finance careers.',
    limitedOfferOptions: {
      title: 'Save 57% with an Annual Plan',
      promoPlanType: 'annual',
      comparisonPlanType: 'monthly',
      comparisonPlanBilledText: 'Billed Monthly',
      promoPlanBilledText: 'Billed Annually',
      regularPrice: '$432',
      discountedPrice: '$184.44',
      billedComparisonPrice: '$36',
      discountedPriceCharge: '/year',
      billedComparisonCharge: '/month',
      promoPlanSubscribeClass: 'subscribe-annual',
      comparisonSubscribeClass: 'subscribe-monthly',
      promoPlanButtonText: 'Save 57% Now',
      comparisonPlanButtonText: 'Start Your Career',
    },
    limitedOfferFeatures: [
      {
        name: 'World-class instructors',
      },
      {
        name: 'Exams',
      },
      {
        name: 'New content',
      },
      {
        name: 'Resume builder',
      },
      {
        name: 'Engaging video lessons',
      },
      {
        name: 'Industry-recognized certificates',
      },
      {
        name: 'Hands-on exercises',
      },
      {
        name: 'Personalized support',
      },
      {
        name: 'Career tracks',
      },
      {
        name: 'Self-paced lessons',
      },
      {
        name: 'Downloadable resources',
      },
      {
        name: '30-day refund',
      },
    ],
  },
};
